
const domain = 'https://mjm.miaoyui.com/mjm/api' // 线上
// const domain = 'http://192.168.101.249:8713/mjm/api' // 本地
export default {
  domain
}


// WEBPACK FOOTER //
// ./src/utils/config.js